export const queryParamKeys = {
    pageNumber: 'pageNumber',
    query: 'query',
};
